import React from 'react';
import PdfIcon from "assets/svg/pdf.png";
import WordIcon from "assets/svg/word.png";
import ImageIcon from "assets/svg/jpg.png";

const DocumentIcon = ({ type }) => {
  switch (type.toLowerCase()) {
    case 'pdf':
      return <img src={PdfIcon} alt="PDF Icon" width={24} height={24} />;
    case 'docx':
      return <img src={WordIcon} alt="Word Icon" width={24} height={24} />;
    case 'jpeg':
    case 'jpg':
    case 'png':
      return <img src={ImageIcon} alt="Image Icon" width={24} height={24} />;
    default:
      return null;
  }
};

export default DocumentIcon;
